import Table from 'react-bootstrap/Table'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'

export default function ScannersTable({ scanners, handleShowScannerModal }) {
  return (
    <>
      <Row className="justify-content-md-end mb-3">
        <Col md="auto">
          <Button variant="primary" onClick={() => handleShowScannerModal()}>
            Add Scanner
          </Button>
        </Col>
      </Row>
      {scanners && scanners.length > 0 ? (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Entry Point</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {scanners.map((scanner) => (
              <tr key={scanner.id}>
                <td>{scanner.firstName}</td>
                <td>{scanner.email}</td>
                <td>{scanner.entryPoint?.name || '—'}</td>
                <td onClick={() => handleShowScannerModal(scanner)}>
                  <Button variant="link">Edit</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Alert variant="light" className="mb-0">
          No scanners yet. Create a scanner account to use the check-in app.
        </Alert>
      )}
    </>
  )
}
